import React from 'react'
import { CarmoolaLogo, ExperianLogo, InterstitialClearscoreLogo, ZutoLogoSmallDesktop } from '@zuto/icons'
import BrandStripHeader from '@zuto/atoms/src/Mui/Header/BrandStripHeader'

type Props = {
  source: string
}
const PartnerBrandHeader: React.FC<Props> = ({source}) => {
  const renderLogo = (source: string) => {
    switch (source) {
      case 'clearscore':
        return <InterstitialClearscoreLogo aria-label="ClearScore" data-testid="clearscore-logo" />
      case 'experian':
        return <ExperianLogo aria-label="Experian" data-testid="experian-logo" />
      case 'carmoola':
        return <CarmoolaLogo aria-label="Carmoola" data-testid="carmoola-logo" />
      default:
        return null
    }
  }

  return (
    <BrandStripHeader
      primaryLogo={
        <ZutoLogoSmallDesktop aria-label="Zuto" data-testid="zuto-logo" />
      }
      partnerLogo={renderLogo(source)}
    />
  )
}

export default PartnerBrandHeader
